import invariant from 'invariant'
import {
  ServiceType,
  WorkflowTriggerType,
  WorkflowTrigger,
} from '../../../../types'

const findTriggerDescriptor = (
  service: ServiceType,
  triggerType: WorkflowTriggerType
) => {
  if (!service.triggerTypes) {
    return null
  }

  return service.triggerTypes.find(
    (triggerDescriptor) => triggerDescriptor.key === triggerType
  )
}

const findService = (
  services: ServiceType[],
  triggerType: WorkflowTriggerType
) => services.find((service) => findTriggerDescriptor(service, triggerType))

export default function findServiceAndTriggerDescriptorByKey(
  services: ServiceType[],
  trigger: WorkflowTrigger | WorkflowTriggerType
) {
  const triggerType = typeof trigger === 'string' ? trigger : trigger.type

  const service = findService(services, triggerType)

  invariant(service, `Could not find service for trigger "${triggerType}".`)

  const triggerDescriptor = findTriggerDescriptor(service, triggerType)

  invariant(
    triggerDescriptor,
    `Could not find trigger type for trigger "${triggerType}".`
  )

  return {
    service,
    triggerDescriptor,
  }
}
